<template>
  <div>
    <div class="page-footer">
      <div class="page-footer-inner">
        &copy; {{ getCurrentYear }} CaseMGR Solutions, Inc. All Rights Reserved.
        <div class="scroll-to-top">
          <i class="icon-arrow-up"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data(){
      return {
      }
    },
    computed:{
      getCurrentYear:function(){
          const d = new Date();
          let year = d.getFullYear();
          return year
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?5c78e62d